export default "__VITE_ASSET__fTv9ggKZ__"